import { NodeViewContent, NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import { memo } from 'react';

/**
 * CodeBlockComponent is a custom component for the tiptap editor simulating a HTML editor.
 * The props are passed from the tiptap editor if needed (editor, node  etc...)
 *
 * hljs / css styling is located in AssetFormSx -> codeRichTextInputSx, and could
 * be brought over to be setup here in an improvement eg:
 *
 * // Move styles out from the rich text input sx and into the node:
 * const [codeTheme] = useLocalStorage({ ... });
 * <NodeViewWrapper ...>
 *   <Box sx={hljsStyles}>
 *     <NodeViewContent ... />
 *   </Box>
 * </NodeViewWrapper>
 *
 */

const CodeBlockComponent = memo((props: NodeViewProps) => {
  return (
    <NodeViewWrapper
      data-testid="codeblock-wrapper"
      className="codeblock-wrapper"
    >
      <NodeViewContent
        // ts type error, renders in dom as <code>
        as={'code' as any}
        data-testid="codeblock-content"
        className="codeblock-content"
      />
    </NodeViewWrapper>
  );
});
CodeBlockComponent.displayName = 'CodeBlockComponent';

export default CodeBlockComponent;
